import { Avatar, Pagination, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import PageLoader from "../sub/PageLoader";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function UnitPositionsTable(props) {
  const [canStart, setCanStart] = useState(false);
  const [page, setPage] = useState(1);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    setCanStart(true);
    setPositions(props.positions);
  }, [props.positions]);

  const columns = [
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text, record) => <div>{record.designation?.name}</div>,
    },
    {
      title: "User role",
      dataIndex: "userRole",
      key: "userRole",
      render: (text, record) => <div>{record.role?.name}</div>,
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <>
          {record.user.id ? (
            record.user.status != "Invited" ? (
              <div className="flex items-center">
                {record.user?.imageUrl ? (
                  <Avatar src={record.user?.imageUrl} />
                ) : (
                  <Avatar>
                    {record.user?.firstName?.charAt(0).toUpperCase()}
                  </Avatar>
                )}
                <div className="mx-1">
                  <div className="max-w-xs truncate overflow-hidden">
                    {record.user?.firstName + " " + record.user?.lastName}
                  </div>
                  {/* <div className="text-xs -mt-1">Name</div> */}
                </div>
              </div>
            ) : (
              <div className="max-w-xs truncate overflow-hidden">
                {record.user?.email}
              </div>
            )
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (text, record) => (
        <Tag color={"green"}>{record.status || "-"}</Tag>
      ),
    },
  ];

  return (
    <>
      {canStart ? (
        <>
          <Table
            columns={columns}
            dataSource={positions}
            pagination={false}
            loading={props.loading}
          />
          <div className="text-center mt-6">
            <Pagination
              onChange={(num) => {
                props.changePage(num);
                setPage(num);
              }}
              current={page}
              total={props.data?.totalCount || 0}
              pageSize={LIMIT_PER_PAGE}
            />
          </div>
        </>
      ) : (
        <PageLoader />
      )}
    </>
  );
}

export default UnitPositionsTable;
